import React, { useEffect } from 'react';
import { Route, Switch, useParams } from 'react-router-dom';
import './App.css';
import Header from './pages/layout/header/main';
import rutas from './routes/config';
import Transparencia from './pages/layout/transparencia';
import Footer from './pages/layout/footer';
import { base_url } from "../src/constants";


function App() { 
  let  page  = useParams();  
  useEffect(()=>{
  if(window.location.pathname===`/${base_url}/busqueda_avanzada`) (document.getElementById('palabra') as HTMLInputElement).value =''
  if(!(window.location.pathname).includes(`/${base_url}/busqueda`)){
    if(!(window.location.pathname).includes(`/${base_url}/obras/`)){
      const keysToRemove = ["tituloBA","autorBA","temaBA","ISBNBA","palabraClaveBA","documentoBA","anios_values","colecciones_values","aniosBA","colBA", "palabra"]
      for (const key of keysToRemove) localStorage.removeItem(key); 
      (document.getElementById('palabra') as HTMLInputElement).value =''
    }
  }
},[page]); 
  return (   
    <div className="App">
      <header>
          <Header />        
      </header>
      <main className="contenedor_principal">
      <Switch>        
        { rutas.map( (ruta) =>
          <Route key={ruta.path} exact={ruta.exact} path={ruta.path} > 
              <ruta.component />
          </Route>
        ) }
      </Switch> 
      </main>
      <footer>
        <Transparencia/>
        <Footer/>
      </footer>
    </div>  
  );
}

export default App;
